<div class="row pb-4">
  <div class="col-9">
    <div class="table-responsive">
      <div class="d-flex justify-content-between">
        <h3>Support Allocation</h3>
        <div class="d-flex align-items-center">
          <a class="link" (click)="exportExcelFile()"
            ><i class="pi pi-cloud-download"></i> Export excel</a
          >
        </div>
      </div>
      <div class="order-dropdown add">
        <p-table
          #dt
          [value]="bacDashboardInformation"
          styleClass="p-datatable-customers ordersLineItems no-wrap poctablecustomscrollbar"
          [rowHover]="true"
          [rows]="10"
          [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[10, 25, 50]"
          [paginator]="false"
          [filterDelay]="0"
          scrollHeight="400px"
          [scrollable]="true">
          <ng-template pTemplate="header">
            <tr>
              <th>Employee Id</th>
              <th>Support</th>
              <th>Title</th>
              <th>Support %</th>
              <th>Total Bill GP$</th>
              <th>Total Open GP (backlog)</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-baclistList let-rowIndex="rowIndex">
            <tr
              class="p-selectable-row mousepointer"
              [ngClass]="{ 'line-gray': !baclistList?.isActive }">
              <td class="name mousepointer">{{ baclistList?.bcNumber }}</td>
              <td class="name mousepointer">
                {{ baclistList?.supportBreakDown }}
              </td>
              <td class="name mousepointer">{{ baclistList?.title }}</td>
              <td class="name mousepointer">
                {{ baclistList?.supportPercentage }}
              </td>
              <td class="name mousepointer">
                <a class="link" (click)="clickTotalBillGp(baclistList)">
                  {{ baclistList?.totalBillGp | currency }}</a
                >
              </td>
              <td class="name mousepointer">
                <a class="link" (click)="clickTotalOpenGp(baclistList)">
                  {{ baclistList?.totalOpenGP | currency }}
                </a>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="20">No data found.</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="footer" *ngIf="totals">
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td class="align-left">
                {{ totals.totalSupportPercentage | number: "1.2-2" }}
              </td>
              <td class="align-left">
                {{ totals.totalBillGp | number: "1.2-2" }}
              </td>
              <td class="align-left">
                {{ totals.totalOpenGP | number: "1.2-2" }}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    <br />
  </div>
  <div class="col-3">
    <jni-support-map-pie-chart
      [bacDashboardInformation]="pieChart"></jni-support-map-pie-chart>
  </div>
</div>

<jni-modal-stacker
  *ngIf="orderListingDisplayModal"
  [displayModal]="orderListingDisplayModal"
  (closeEvent)="closeOrderListingModal()">
  <h1 class="panelHeading">Order Listing</h1>
  <div class="panelBody">
    <jni-orders
      [isAdditionalFilters]="true"
      [isFromSupportAllocation]="true"></jni-orders>
  </div>
</jni-modal-stacker>

<jni-modal-stacker
  *ngIf="displayModal"
  [displayModal]="displayModal"
  (closeEvent)="closeBcLedgerModal()">
  <div class="panelBody">
    <jni-ytdgp
      *ngIf="bcLedgerStacker.Path === 'YTDGP'"
      [salesOrderNumberFilter]="true"
      [bcLedgerStacker]="bcLedgerStacker">
    </jni-ytdgp>
  </div>
</jni-modal-stacker>
